
'use strict';

define('views/academy/ItemIntroductionView.js',['require','translate','prop-types','react','create-react-class','component!AcademyPaneComponent','component!AcademyCourseComponent','component!Raw','mixins/TransitionMixin'],function (require) {
  var t = require('translate');
  var PropTypes = require('prop-types');
  var React = require('react');
  var ReactCreateClass = require('create-react-class');

  var AcademyPane = require('component!AcademyPaneComponent');
  var AcademyCourse = require('component!AcademyCourseComponent');
  var Raw = require('component!Raw');
  var TransitionMixin = require('mixins/TransitionMixin');

  var translations = {
    heading: t('Your first project #academy_item_introduction'),
    subHeading: t('Pick a real project your organisation is working on, and fill in the details using this list. #academy_item_introduction')
  };

  var courseTranslations = {
    login: t('Log in to Podio #academy_item_introduction'),
    fillTitle: React.createElement(
      Raw,
      null,
      t('Fill in the {0} #academy_item_introduction').format('<em>{0}</em>').format(t('Title #academy_item_introduction'))
    ),
    fillDeadline: React.createElement(
      Raw,
      null,
      t('Fill in the {0} #academy_item_introduction').format('<em>{0}</em>').format(t('Deadline #academy_item_introduction'))
    ),
    enterModifyTemplate: React.createElement(
      Raw,
      null,
      t('Click {0} #academy_item_introduction').format('<em>{0}</em>').format(t('Modify Template #academy_item_introduction'))
    ),
    addTextField: React.createElement(
      Raw,
      null,
      t('Drag in a {0} field #academy_item_introduction').format('<em>{0}</em>').format(t('Text #academy_item_introduction'))
    ),
    renameTextFieldToDescription: React.createElement(
      Raw,
      null,
      t('Rename {0} field to {1} #academy_item_introduction').format('<em>{0}</em>', '<em>{1}</em>').format(t('Text #academy_item_introduction'), t('Description #academy_item_introduction'))
    ),
    saveTemplate: React.createElement(
      Raw,
      null,
      t('Click {0} to save Template #academy_item_introduction').format('<em>{0}</em>').format(t('Done #academy_item_introduction'))
    ),
    fillDescription: React.createElement(
      Raw,
      null,
      t('Fill in the {0} field #academy_item_introduction').format('<em>{0}</em>').format(t('Description #academy_item_introduction'))
    ),
    createItem: React.createElement(
      Raw,
      null,
      t('Save {0} #academy_item_introduction').format('<em>{0}</em>').format(t('Project #academy_item_introduction'))
    ),
    navigateToAppView: React.createElement(
      Raw,
      null,
      t('Go back to {0} #academy_item_introduction').format('<em>{0}</em>').format(t('Projects #academy_item_introduction'))
    )
  };

  var ItemIntroductionView = ReactCreateClass({
    mixins: [TransitionMixin],

    propTypes: {
      eventBus: PropTypes.object.isRequired,
      course: PropTypes.object.isRequired
    },

    getChapter: function getChapter() {
      var course = {
        assignments: this.props.course.assignments.concat({
          'id': 'navigateToAppView',
          'completed': false
        })
      };

      return React.createElement(
        'div',
        { className: 'academy-pane-component__content' },
        React.createElement(AcademyCourse, { course: course, translations: courseTranslations })
      );
    },

    open: function open(callback) {
      this.setState({
        isOpen: true
      }, callback);
    },

    close: function close() {
      if (this.state.isOpen) {
        this.setState({
          isOpen: false
        });
      }
    },

    getInitialState: function getInitialState() {
      return {
        isOpen: false
      };
    },

    componentDidMount: function componentDidMount() {
      this._isMounted = true;
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.props.eventBus.on('courseUpdate', function (course) {
        if (this._isMounted) {
          this.setState({
            isOpen: true
          });
        }
      }, this);
    },

    render: function render() {
      var chapter = this.getChapter();

      return React.createElement(
        AcademyPane,
        { heading: translations.heading, subHeading: translations.subHeading, isOpen: this.state.isOpen, eventBus: this.props.eventBus, course: this.props.course },
        chapter
      );
    },

    componentWillUnmount: function componentWillUnmount() {
      this.props.eventBus.off(null, null, this);
      this._isMounted = false;
    }
  });

  return ItemIntroductionView;
});
